import { render, staticRenderFns } from "./ModalTrlLog.vue?vue&type=template&id=5085082c&scoped=true&"
import script from "./ModalTrlLog.vue?vue&type=script&lang=js&"
export * from "./ModalTrlLog.vue?vue&type=script&lang=js&"
import style0 from "./ModalTrlLog.vue?vue&type=style&index=0&id=5085082c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5085082c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
